import React from "react";
import { Dialog, DialogTitle, DialogContent, List, ListItem, ListItemText } from "@mui/material";
import { User } from "../../types/user";
import { OrganizationDriverAvailabilitySlot } from "../../types/availability";

interface Props {
  open: boolean;
  onClose: () => void;
  users: User[];
  slots: OrganizationDriverAvailabilitySlot[]; 
  onSelectUser: (user: User, slot: OrganizationDriverAvailabilitySlot | undefined) => void;
}

const MultipleDriversModal = ({ open, onClose, users, slots, onSelectUser }: Props) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>Available Drivers</DialogTitle>
      <DialogContent>
        <List>
  {users.map((user) => {
    const slot: OrganizationDriverAvailabilitySlot | undefined = slots.find((s) => s.userId === user.id);
    const start = slot ? new Date(slot.startTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : '';
    const end = slot ? new Date(slot.endTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : '';
    return (
        <ListItem button key={user.id} onClick={() => onSelectUser(user, slot)}>
                <ListItemText primary={`${user.firstName} ${user.lastName}`} secondary={`${start} – ${end}`} />
              </ListItem>
            );
          })}
        </List>
      </DialogContent>
    </Dialog>
  );
};

export default MultipleDriversModal;
